export default __webpack_public_path__ + "static/media/ds-logo-coloured.cf6e072e.svg";